import useApiMutation from 'shared/hooks/use-api-mutation';
import {ProductProps} from '../types';
import productsKeys from '../util/products-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

const useReorderAdditionalGroupConfigsIndexes = (productId: string) => {
  const {setData} = useQueryHelpers();

  const onSuccess = (data: ProductProps) =>
    setData(productsKeys.details(productId), data);

  return useApiMutation({
    url: `/products/${productId}/additional-groups-config/reorder-indexes`,
    method: 'PATCH',
    errorTitle: 'Erro ao ordenar grupo de adicionais do produto',
    onSuccess,
  });
};

export default useReorderAdditionalGroupConfigsIndexes;
